import { BreadcrumbItem, Breadcrumbs } from "@light-technology/components";
import { SkeletonLine } from "./skeletons";

type BreadcrumbItem = { label: string; to?: string } | null;

type PlaybookBreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
};

export const PlaybookBreadcrumb = ({
  items,
  className,
}: PlaybookBreadcrumbProps) => {
  return (
    <Breadcrumbs type="text" className={className}>
      {items.map((item, i) =>
        item === null ? (
          <BreadcrumbItem key={i}>
            <SkeletonLine className="w-32" subtle />
          </BreadcrumbItem>
        ) : (
          <BreadcrumbItem key={i} href={item.to}>
            {item.label}
          </BreadcrumbItem>
        ),
      )}
    </Breadcrumbs>
  );
};
